import { getToken } from './auth';
import { GHIN_STAGING_URL } from './config';

const HANDICAP_HISTORY_PATH = 'golfers';

export interface HandicapRevision {
  ID: number;
  GHINNumber: number;
  Assoc: number;
  AssociationName: string;
  Club: number;
  ClubName: string;
  Service: number;
  RevDate: string;
  Display: number;
  Value: number;
  MessageClubAuthorized: string | null;
  LowHIDisplay: number;
  LowHI: number;
  Hard_Soft_Cap: string;
  Hard_Cap: string;
  Soft_Cap: string;
  HIBeforeSoftCapDisplay: number;
  HIBeforeSoftCap: number;
  HIBeforeHardCapDisplay: number;
  HIBeforeHardCap: number;
  Hidden: boolean;
}

export interface HandicapHistoryResponse {
  success: boolean;
  status: number;
  data?: {
    handicap_revisions: HandicapRevision[];
  };
  error?: string;
}

export async function golfersHandicapHistory(ghin: string): Promise<HandicapHistoryResponse> {
  const token = getToken();
  if (!token) {
    return {
      success: false,
      status: 401,
      error: 'Not authenticated',
    };
  }

  const today = new Date();
  const startOfYear = new Date(today.getFullYear(), 0, 1);
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const formatDate = (date: Date) => date.toISOString().split('T')[0];

  const params = new URLSearchParams({
    date_begin: formatDate(startOfYear),
    date_end: formatDate(yesterday),
    rev_count: '0',
  });

  const url = `${GHIN_STAGING_URL}/${HANDICAP_HISTORY_PATH}/${ghin}/handicap_history.json?${params}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  const data = await response.json();

  if (response.ok) {
    return {
      success: true,
      status: response.status,
      data,
    };
  }

  return {
    success: false,
    status: response.status,
    error: data.message || 'Failed to fetch handicap history',
  };
}
